export default class TextAnimationOnHover {
  init() {
    this.textAnimationContainerList = Array.from(
      document.getElementsByClassName('text-animation-on-hover__container')
    );

    if (!this.textAnimationContainerList.length) {
      return;
    }

    for (let containerElement of this.textAnimationContainerList) {
      const textElement = containerElement.querySelector(
        '.text-animation-on-hover__text'
      );

      const anchorObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              textElement.classList.add('text-animation-on-hover__text--show');
            }
          });
        },
        {
          root: null,
          rootMargin: '0px',
          threshold: 1,
        }
      );

      anchorObserver.observe(containerElement);
    }
  }
}
